module.exports = __webpack_public_path__ + "img/202309_05.b7dad10c.jpg";